export default defineNuxtRouteMiddleware(async (to) => {
  // Pages that are not yet shipped and should bounce to the landing route if
  // visited directly. NOTE: /login and /otp are deliberately NOT here — they are
  // the LIVE custom native-auth sign-in flow (gated by nativeAuthLoginEnabled).
  // Hiding them here would fight auth.global.ts (which redirects unauthenticated
  // users TO /login) and produce an infinite /login → / → /login redirect loop.
  const privatePaths = new Set<string>([ '/signed-out', '/index-old', '/verify-email'])
  // ignore Nuxt internals + your API routes
  if (to.path.startsWith('/api/')) return
  if (privatePaths.has(to.path)) {
    let redirect = ''//'/household/overview'
    await navigateTo(`/${encodeURIComponent(redirect)}`, { external: true })
    return
  }
})
